<nz-spin [nzSpinning]="isLoading">
    <div style="overflow-x: auto; max-width: 70vw">
        <nz-table nzBordered [nzData]="userData" [nzFrontPagination]="false">
            <thead>
                <tr>
                    <th></th>
                    <th>{{ "UserId" | translate }}</th>
                    <th>{{ "ChineseName" | translate }}</th>
                    <th>{{ "EnglishName" | translate }}</th>
                    <th>{{ "VendorCodeOrDeptId" | translate }}</th>
                    <th>{{ "Email" | translate }}</th>
                    <th>{{ "IdentityType" | translate }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let user of userData">
                    <td>
                        <nz-radio-group [(ngModel)]="selectedUser"
                            [nzDisabled]="user.userType === originalUser.userType || (user.userType!=='User' && user.isAccountLocked)">
                            <label nz-radio [nzValue]="user"></label>
                        </nz-radio-group>
                    </td>
                    <td>{{ user.userId }}</td>
                    <td>{{ user.chineseName }}</td>
                    <td>{{ user.englishName }}</td>
                    <td>{{ user.userType==='User'?user.deptId:user.vendorCode }}</td>
                    <td>{{ user.email }}</td>
                    <td>{{ layoutServ.getUserTypeDisplay(user.userType) }}</td>
                </tr>
            </tbody>
        </nz-table>
    </div>
</nz-spin>